import React from "react";
import AboutArea from "./AboutArea";
import IndustrialConnects from "./IndustrialConnects";
import MeetFaculty from "./MeetFaculty";

const AboutPage = () => {
  return (
    <div className="pt-6">
      {/* <h1 className="text-center text-3xl mt-5 font-bold" >About Us</h1> */}
      
      <AboutArea />
      <MeetFaculty />
      <IndustrialConnects />
    </div>
  );
};

export default AboutPage;
